"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _query = require("@reduxjs/toolkit/query");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _reactRedux = require("react-redux");

var _StepTitle = _interopRequireDefault(require("../../../../components/StepTitle/StepTitle"));

var _providers = require("../../../../providers");

var _GiftPreview = _interopRequireDefault(require("../GiftPreview/GiftPreview"));

var _MessagePreview = _interopRequireDefault(require("../MessagePreview/MessagePreview"));

var _StepperFooter = _interopRequireDefault(require("../../../../components/Stepper/StepperFooter"));

var _hooks = require("../../../../hooks");

var _activeStep = require("../../../../store/ui/activeStep");

var _IntegrationConnectionWarning = _interopRequireDefault(require("../../../../components/IntegrationConnection/IntegrationConnectionWarning"));

var _SendBatchButton = _interopRequireDefault(require("../SendBatchButton/SendBatchButton"));

var _StepperOutlet = _interopRequireDefault(require("../../../../components/Stepper/StepperOutlet"));

var _Success = require("../../../Success");

var _useTrackGiftingFlow = require("../../../../hooks/useTrackGiftingFlow");

var _user = require("../../../../../Shared/store/user");

var _features = require("../../../../../Shared/store/features");

var _giftingFlow = require("../../../../helpers/giftingFlow.helpers");

var styles = {
  paper: {
    p: 1.5,
    mt: 1.5
  },
  sectionTitle: {
    color: 'primary.main',
    lineHeight: '1.25rem',
    fontWeight: 700
  },
  titleTooltip: {
    ml: 1
  },
  editBtn: {
    p: 0,
    ["& > .".concat(_material.buttonClasses.startIcon, " > *:nth-of-type(1)")]: {
      fontSize: '16px'
    }
  },
  hidden: {
    display: 'none'
  }
};
var BATCH_QUERY_POLLING_STATUSES = {
  IDLE: undefined,
  POLLING: 3000,
  OFF: 0
};

var SendingBatchForm = function SendingBatchForm() {
  var _campaign$defaultProd, _batch$messaging;

  var hasSalesforceHasOptedOutFF = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.SALESFORCE_HAS_OPTED_OUT));
  var hasBudgetManagementLimit = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.BUDGET_MANAGEMENT_LIMIT));

  var _useState = (0, _react.useState)(BATCH_QUERY_POLLING_STATUSES.IDLE),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      pollingInterval = _useState2[0],
      setPollingInterval = _useState2[1];

  var userId = (0, _reactRedux.useSelector)(_user.User.selectors.getUserId);

  var _useGiftingFlowSteps = (0, _hooks.useGiftingFlowSteps)(),
      setActiveStep = _useGiftingFlowSteps.setActiveStep;

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      batchId = _useGiftingFlowContex.batchId;

  var _usePutSendProspectin = (0, _services.usePutSendProspectingBatchByIdMutation)(),
      _usePutSendProspectin2 = (0, _slicedToArray2.default)(_usePutSendProspectin, 2),
      sendBatchById = _usePutSendProspectin2[0],
      _usePutSendProspectin3 = _usePutSendProspectin2[1],
      isSendingPending = _usePutSendProspectin3.isLoading,
      isSendingBatchFulfilled = _usePutSendProspectin3.isSuccess;

  var _useGetProspectingBat = (0, _services.useGetProspectingBatchByIdQuery)(batchId ? {
    batchId: Number(batchId)
  } : _query.skipToken, {
    pollingInterval
  }),
      batch = _useGetProspectingBat.data,
      isBatchQueryFulfilled = _useGetProspectingBat.isSuccess,
      isFetching = _useGetProspectingBat.isFetching,
      refetchProspectingBatchQuery = _useGetProspectingBat.refetch;

  var hasBatchSyncFinished = !hasSalesforceHasOptedOutFF || !isFetching && isBatchQueryFulfilled && (0, _giftingFlow.isBatchFinishedStatus)({
    batch
  });
  var isPollingBatchQuery = pollingInterval === BATCH_QUERY_POLLING_STATUSES.POLLING;
  var isPollingBatchQueryIdle = pollingInterval === BATCH_QUERY_POLLING_STATUSES.IDLE;
  var shouldStopPollingBatchQuery = isSendingBatchFulfilled && hasBatchSyncFinished && isPollingBatchQuery;

  if (isSendingBatchFulfilled && isPollingBatchQueryIdle) {
    refetchProspectingBatchQuery();
    setPollingInterval(BATCH_QUERY_POLLING_STATUSES.POLLING);
  }

  if (shouldStopPollingBatchQuery) setPollingInterval(BATCH_QUERY_POLLING_STATUSES.OFF);
  var sendAsId = (batch === null || batch === void 0 ? void 0 : batch.meetingHosts.ownerId) || (batch === null || batch === void 0 ? void 0 : batch.ownerId);
  var meetingOwnerId = (batch === null || batch === void 0 ? void 0 : batch.meetingHosts.ownerId) || (batch === null || batch === void 0 ? void 0 : batch.ownerId);

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)((batch === null || batch === void 0 ? void 0 : batch.campaignId) || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data;

  var teamId = campaign === null || campaign === void 0 ? void 0 : campaign.team.id;

  var _useGetIntegrationWar = (0, _hooks.useGetIntegrationWarningSettings)({
    teamId,
    sendAsId
  }),
      isSendingBlocked = _useGetIntegrationWar.isSendingBlocked;

  var _useGetIntegrationWar2 = (0, _hooks.useGetIntegrationWarningSettings)({
    teamId,
    sendAsId: meetingOwnerId
  }),
      isSendingBlockedByMeetingOwner = _useGetIntegrationWar2.isSendingBlocked;

  var _useGetBudgetUtilizat = (0, _services.useGetBudgetUtilizationByUserIdQuery)({
    userId
  }, {
    skip: !hasBudgetManagementLimit
  }),
      refetchBudgetUtilization = _useGetBudgetUtilizat.refetch;

  var _usePutScheduleProspe = (0, _services.usePutScheduleProspectingBatchByIdMutation)(),
      _usePutScheduleProspe2 = (0, _slicedToArray2.default)(_usePutScheduleProspe, 2),
      scheduleBatchById = _usePutScheduleProspe2[0],
      isSendingScheduleBatchFulfilled = _usePutScheduleProspe2[1].isSuccess;

  var shouldTriggerBudgetRefetch = isSendingBatchFulfilled || isSendingScheduleBatchFulfilled;
  (0, _react.useEffect)(function () {
    if (shouldTriggerBudgetRefetch) {
      // TODO: (PD-12735) Remove timeout w/ solution to race condition
      setTimeout(function () {
        refetchBudgetUtilization();
      }, 1500);
    }
  }, [shouldTriggerBudgetRefetch, refetchBudgetUtilization]);

  var _GlobalMessage$useGlo = _services.GlobalMessage.useGlobalMessage(),
      showGlobalMessage = _GlobalMessage$useGlo.showGlobalMessage;

  var isSendingFulfilled = isSendingBatchFulfilled && hasBatchSyncFinished || isSendingScheduleBatchFulfilled;
  var stepTitle = isSendingFulfilled ? "Gift".concat(batch && batch.giftsTotal > 1 ? 's' : '', " sent!") : 'Preview & send';
  var subTitle = isSendingFulfilled ? undefined : 'Step 4/4';
  var canSendBatch = !(batch !== null && batch !== void 0 && batch.sentAt) && !isSendingFulfilled;
  var canEditProduct = ((campaign === null || campaign === void 0 ? void 0 : campaign.productsOverrideEnabled) || !!(campaign !== null && campaign !== void 0 && (_campaign$defaultProd = campaign.defaultProducts) !== null && _campaign$defaultProd !== void 0 && _campaign$defaultProd.length)) && canSendBatch;
  var canEditMessage = ((campaign === null || campaign === void 0 ? void 0 : campaign.messageOverrideEnabled) || (campaign === null || campaign === void 0 ? void 0 : campaign.recipientActionOverrideEnabled)) && canSendBatch;
  var isMeetingOwnerWarningVisible = sendAsId !== meetingOwnerId && canSendBatch;
  var trackGiftingFlowPreviewStepProductEditButtonClicked = (0, _useTrackGiftingFlow.useGiftingFlowPreviewStepProductEditButtonClicked)();
  var trackGiftingFlowPreviewStepMessageEditButtonClicked = (0, _useTrackGiftingFlow.useGiftingFlowPreviewStepMessageEditButtonClicked)();

  var handleEditMessage = function handleEditMessage() {
    setActiveStep(_activeStep.GiftingFlowStep.Messaging);
    trackGiftingFlowPreviewStepMessageEditButtonClicked();
  };

  var handleEditProduct = function handleEditProduct() {
    setActiveStep(_activeStep.GiftingFlowStep.Gift);
    trackGiftingFlowPreviewStepProductEditButtonClicked();
  };

  var handleSendGiftBatch = (0, _react.useCallback)(function () {
    if (batchId) {
      sendBatchById({
        batchId
      }).unwrap().then(function () {
        showGlobalMessage({
          type: _services.MessageType.Success,
          text: 'Your gifts have been sent.'
        });
      });
    }
  }, [batchId, sendBatchById, showGlobalMessage]);
  var handleSchedule = (0, _react.useCallback)(function (scheduleAt) {
    if (batchId) {
      scheduleBatchById({
        batchId,
        body: {
          scheduleAt
        }
      }).unwrap().then(function () {
        showGlobalMessage({
          type: _services.MessageType.Success,
          text: 'Your gifts have been scheduled.'
        });
      });
    }
  }, [batchId, scheduleBatchById, showGlobalMessage]);

  var renderBatchFulfilledSuccessView = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!(batch !== null && batch !== void 0 && batch.sentAt) && /*#__PURE__*/_react.default.createElement(_StepperOutlet.default, {
    sx: styles.hidden
  }), /*#__PURE__*/_react.default.createElement(_StepTitle.default, {
    title: stepTitle,
    subTitle: subTitle
  }), /*#__PURE__*/_react.default.createElement(_material.Paper, {
    sx: styles.paper
  }, /*#__PURE__*/_react.default.createElement(_Success.Success, null)));

  if (isSendingBatchFulfilled && !hasBatchSyncFinished) return /*#__PURE__*/_react.default.createElement(_material.Box, {
    pb: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Paper, {
    sx: styles.paper
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    minHeight: "25vh",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    size: 40
  }))));
  if (isSendingBatchFulfilled && hasBatchSyncFinished) return renderBatchFulfilledSuccessView;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    pb: 3
  }, (!!(batch !== null && batch !== void 0 && batch.sentAt) || isSendingFulfilled) && /*#__PURE__*/_react.default.createElement(_StepperOutlet.default, {
    sx: styles.hidden
  }), /*#__PURE__*/_react.default.createElement(_StepTitle.default, {
    title: stepTitle,
    subTitle: subTitle
  }), canSendBatch && /*#__PURE__*/_react.default.createElement(_IntegrationConnectionWarning.default, {
    teamId: teamId,
    sendAsId: sendAsId
  }), isMeetingOwnerWarningVisible && /*#__PURE__*/_react.default.createElement(_IntegrationConnectionWarning.default, {
    teamId: teamId,
    sendAsId: meetingOwnerId,
    mt: 2
  }), /*#__PURE__*/_react.default.createElement(_material.Paper, {
    sx: styles.paper
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.sectionTitle
  }, "Bulk Gifts (", batch === null || batch === void 0 ? void 0 : batch.giftsTotal, ")"), canEditProduct && /*#__PURE__*/_react.default.createElement(_ui.Button, {
    onClick: handleEditProduct,
    sx: styles.editBtn,
    disableRipple: true,
    variant: "text",
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "pencil"
    })
  }, "Edit")), /*#__PURE__*/_react.default.createElement(_GiftPreview.default, null), /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    my: 2
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.sectionTitle,
    display: "flex"
  }, "Message", !!(batch !== null && batch !== void 0 && (_batch$messaging = batch.messaging) !== null && _batch$messaging !== void 0 && _batch$messaging.messageBody) && /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    placement: "top",
    title: "The highlighted text is custom data placeholders for this message preview and will be replaced with the values of your contacts and gift information upon sending."
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    sx: styles.titleTooltip,
    icon: "exclamation-circle",
    color: "text",
    fontSize: 1
  }))), canEditMessage && /*#__PURE__*/_react.default.createElement(_ui.Button, {
    onClick: handleEditMessage,
    sx: styles.editBtn,
    disableRipple: true,
    variant: "text",
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "pencil"
    })
  }, "Edit")), /*#__PURE__*/_react.default.createElement(_MessagePreview.default, null)), canSendBatch && /*#__PURE__*/_react.default.createElement(_StepperFooter.default, {
    isLoading: isSendingPending,
    nextButton: /*#__PURE__*/_react.default.createElement(_SendBatchButton.default, {
      disabled: isSendingBlocked || isSendingBlockedByMeetingOwner || isSendingPending,
      isSendingFulfilled: isSendingFulfilled,
      sendBatchById: handleSendGiftBatch,
      scheduleBatchById: handleSchedule
    })
  }));
};

var _default = SendingBatchForm;
exports.default = _default;